import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import { Tabs, Tab} from "@material-ui/core";

import { API_ENDPOINTS, subscribeToEndpointUpdates } from "../../common/constants";

const useStyles = makeStyles((theme) => ({
  versionSelector: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    padding: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e0e0e0",
  },
  tab: {
    textTransform: "capitalize",
  },
  tabsRoot: {
    minHeight: "40px",
    position: "relative",
    zIndex: 1,
    "& .MuiTab-root": {
      minHeight: "40px",
      textTransform: "capitalize",
      fontSize: "12px",
      fontWeight: "500",
      color: "#f44336",
      padding: "8px 16px",
      minWidth: "110px",
      borderRadius: "6px",
      margin: "0 4px",
      transition: "all 0.2s ease",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "rgba(244, 67, 54, 0.08)",
        color: "#f44336",
      },
    },
    "& .Mui-selected": {
      color: "#ffffff",
      fontWeight: "600",
      backgroundColor: "#f44336",
      boxShadow: "0 2px 4px rgba(244, 67, 54, 0.3)",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
  }
}));

export default function VersionSelector({ selectedVersion, onVersionChange }) {
  const classes = useStyles();
  
  const [currentEndpoints, setCurrentEndpoints] = useState(API_ENDPOINTS);

  useEffect(() => {
    const unsubscribe = subscribeToEndpointUpdates((updatedEndpoints) => {
      console.log('VersionSelector received endpoint update:', updatedEndpoints);
      setCurrentEndpoints({ ...updatedEndpoints });
    });
    console.log(currentEndpoints, 'currentEndpoints');

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);

  const handleChange = (event, newValue) => {
    onVersionChange(newValue);
  };

  return (
    <div className={classes.versionSelector}>
      <Tabs
        value={selectedVersion}
        onChange={handleChange}
        className={classes.tabsRoot}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
      >
        {Object.keys(currentEndpoints).map((version) => (
          <Tab
            key={version}
            label={version?.split("_").join(" ")}
            value={version}
            className={classes.tab}
          />
        ))}
      </Tabs>
    </div>
  );
} 